
<div class="access-denied">
    <h3 style="color:orange;"> Access denied </h3>
</div>